import { notification } from 'antd'

import BillAPI from '@apis/branch/bill'

import ConfirmModal from '@components/molecules/ConfirmModal'

type Props = {
  hqId: number
  branchId: number
  billId?: number
  visible: boolean
  onClose: () => void
  onDone: () => void
}

export default function BillDeleteModal({ hqId, branchId, billId, visible, onClose, onDone }: Props): JSX.Element {
  const onConfirm = async () => {
    if (!billId) return
    await BillAPI.deleteBill({ hqId, branchId, billId })
    notification.success({ message: '삭제되었습니다.' })
  }

  return (
    <ConfirmModal
      title="청구서 삭제"
      description="청구서를 삭제하면 결제 내역도 삭제됩니다."
      okText="삭제"
      onConfirm={onConfirm}
      visible={visible}
      onClose={onClose}
      onDone={onDone}
    />
  )
}
